<div class="flex flex-col items-center justify-center">
  <form class="flex flex-col w-full h-full gap-4" (ngSubmit)="closeModal()">
    <h1 class="text-2xl">Select a Deadline</h1>
    <p style="max-width: 500px">By what date would you like these proposed changes to be implemented?</p>
    <tandem-form-input
      [form]="formGroup"
      [controlName]="'deadline'"
      [inputType]="'date'"
      [inputId]="'deadline'"
      [label]="'Deadline'"
      [placeholder]="'Deadline'"></tandem-form-input>
    <div class="flex flex-row justify-center gap-6">
      <tandem-button theme="outline" [color]="'red'" [onClick]="closeModal.bind(this, false)">Cancel</tandem-button>
      <tandem-button type="submit" theme="outline" [color]="'primary'" [onClick]="createGoals.bind(this)">Create Goals</tandem-button>
    </div>
  </form>
</div>
